import Vue from 'vue'
import './utils/utils';
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

//crypt-js
// import VueCryptojs from 'vue-cryptojs'
//
// Vue.use(VueCryptojs)
// import '@coreui/dist/css/coreui.min.css'
// import 'core-js/stable'
// import CoreuiVue from '@coreui/vue'
// import { iconsSet as icons } from './assets/icons/icons.js'
// import '@coreui/coreui/dist/css/coreui.css';
// Vue.use(CoreuiVue)
//vue-router
import router from './router'

// plugins
import plugins from './components/plugins'
import './icons' // icon

// 注册自定义指令
import './directives'
// import SvgIcon from '@/components/SvgIcon'// svg component

// register globally
// Vue.component('svg-icon', SvgIcon)
// const req = require.context('./components/svg', false, /\.svg$/)
// const requireAll = requireContext => requireContext.keys().map(requireContext)
// requireAll(req)
Vue.use(plugins);

//aixos
import axios from './utils/request.js'
// import Axios from 'axios'

Vue.prototype.$http = axios;

//bootstrat
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import App from './App.vue'

Vue.config.productionTip = false


// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)


import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
import VueFullscreen from 'vue-fullscreen'

Vue.use(VueFullscreen)

// vuex
import store from './store'

/** 处方列表弹窗深色底：全局靠后加载，覆盖 Element 默认白底 */
import '@/assets/css/clinic-cf-dialog.css'

const token = localStorage.getItem('token')
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}
new Vue({
    router,
    store,
    components: {App},
    // icons,
    render: h => h(App),
}).$mount('#app')
